<template lang="html">
  <form method="post" class="u-form SessionForm" @submit.prevent="submit">
    <div class="SessionForm-inner">
      <h1 class="SessionForm-headline u-mb4">Sign Up</h1>

      <div class="u-richtext u-richtext--scale" v-if="!!errorMessages.length">
        <p class="SessionForm-feedback u-mb2" v-for="(errorMessage, index) in errorMessages">
          {{ errorMessage.message }}
        </p>
      </div>

      <div v-if="!submitted">
        <div class="u-mb2">
          <label for="user-name">Name</label>
          <input id="user-name" type="text" name="user[name]" v-model.trim="name">
        </div>

        <div class="u-mb2">
          <label for="user-email">Email Address</label>
          <input id="user-email" type="email" name="user[email]" v-model.trim="email">
        </div>

        <div class="u-mb2">
          <label for="user-organization">Organization</label>
          <div class="u-relative SignupForm-orgSearch">
            <input type="hidden" value="user[organization_id]" v-model="organizationId">
            <input type="hidden" value="new_org_name" v-model="newOrganizationName">
            <input id="user-organization" type="text" autocomplete="off" @keyup="setOrgs" v-model.trim="organizationQuery">
            <div v-if="showOrgMenu" class="SignupForm-organizations">
              <ul v-if="!!organizations.length">
                <li class="SignupForm-organizations-item" v-for="(organization, index) in organizations">
                  <button @click.prevent="selectOrg(organization)" type="button">{{ organization.name }}</button>
                </li>
              </ul>
              <button type="button" v-if="!!organizationQuery" @click.prevent="createOrg">
                Create new organization "{{ organizationQuery }}"
              </button>
            </div>
          </div>
        </div>

        <div class="u-form--actions u-mt4">
          <button class="Button Button--square" type="submit">Sign Up</button>
        </div>
      </div>

      <div v-if="submitted">
        <p>Thank you for signing up. You will be notified when your account has been approved.</p>
      </div>
    </div>
  </form>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  computed: {
    submitted() { return this.$store.state.signup.submitted; },
    errorMessages() { return this.$store.state.signup.errorMessages; },
    organizations() { return this.$store.state.signup.organizations; },
    organizationId: {
      get() { return this.$store.state.signup.organizationId; },
      set(value) { this.$store.commit('signup/setOrganizationId', value); }
    },
    organizationQuery: {
      get() { return this.$store.state.signup.organizationQuery; },
      set(value) { this.$store.commit('signup/setOrganizationQuery', value); }
    },
    newOrganizationName: {
      get() { return this.$store.state.signup.newOrganizationName; },
      set(value) { this.$store.commit('signup/setNewOrganizationName', value); }
    },
    name: {
      get() { return this.$store.state.signup.name; },
      set(value) { this.$store.commit('signup/setName', value); }
    },
    email: {
      get() { return this.$store.state.signup.email; },
      set(value) { this.$store.commit('signup/setEmail', value); }
    },
    showOrgMenu() {
      if ((!!!this.newOrganizationName && !!!this.organizationId && !!this.organizationQuery) || !!this.organizations.length) {
        return true;
      }
      else {
        return false;
      }
    }
  },
  watch: {
    organizationQuery() {
      this.$store.commit('signup/setNewOrganizationName', null);
    }
  },
  mounted() {
    document.body.addEventListener('click', (event) => this.handleClick(event));
  },
  methods: {
    submit() {
      this.$store.dispatch('signup/createUser');
    },
    setOrgs: debounce( function(event) {
      this.$store.dispatch('signup/getOrganizations');
    }, 200),
    selectOrg(organization) {
      this.$store.dispatch('signup/selectOrganization', organization);
    },
    handleClick(event) {
      let orgSearch = event.target.closest('.SignupForm-orgSearch');

      if (!!!orgSearch) {
        this.$store.commit('signup/setOrganizations', []);
      }
    },
    createOrg() {
      this.$store.commit('signup/setNewOrganizationName', this.organizationQuery);
      this.$store.commit('signup/setOrganizations', []);
    }
  }
}
</script>



// WEBPACK FOOTER //
// signup-form.vue?45c21678